
export const headerData = {
    name: 'Akechi Kondo',
    title: "Hello! I am",
    desciption: "I'm a Finish based Software Engineer & front‑end developer focused on crafting clean & user‑friendly experiences, I am passionate about building excellent software that improves the lives of those around me.",
    image: 'akechi.jpg',
    resumePdf: '/akechi.pdf'
}
